import { Context, ContextInput } from 'bernie-context';
import { SerializedData } from 'bernie-core';
import { KeyedObject } from 'bernie-core/dist/source';
import { BexApiStore, ClientOptions, Headers } from 'bernie-graphql';
import { Request } from 'bernie-http';
import { Logger } from 'bernie-logger';
import { ClientLogger } from 'bernie-client';
import { ApiOperations } from '../common/__generated__/api';

export interface RequestWithTraceInfo extends Request {
  context: Context & {
    traceInfo?: {
      [key: string]: string;
    };
  };
}

export abstract class LXStore extends BexApiStore {
  protected headers!: Headers | undefined;
  protected appConfig: KeyedObject;
  protected logtracing: boolean;

  public constructor(
    bexConfigs: ClientOptions,
    logger: Logger | ClientLogger,
    appConfig: KeyedObject,
    requestOrContext?: ContextInput | RequestWithTraceInfo
  ) {
    let headers;
    if (requestOrContext) {
      headers = LXStore.getRequestHeaders(requestOrContext);
    }
    super(ApiOperations.withClient, bexConfigs, logger, headers, appConfig);
    this.appConfig = appConfig;
    this.logtracing = headers?.cookie?.includes('logtracing=true');
    this.headers = headers;
  }

  private static getRequestHeaders(param: ContextInput | RequestWithTraceInfo): Headers {
    let headers = {};
    if (!param) {
      return headers;
    }

    if ('context' in param && param.context.traceInfo) {
      headers = {
        'Device-User-Agent-ID': param.context.deviceId,
        // eslint-disable-next-line dot-notation
        'trace-id': param.context.traceInfo['Trace-ID'],
        // eslint-disable-next-line dot-notation
        'message-id': param.context.traceInfo['Message-ID'],
        // prettier-ignore
        'cookie': param.headers.cookie
      };
    } else if ('identity' in param) {
      headers = {
        'Device-User-Agent-ID': param.identity.duaid
      };
    }

    return headers;
  }

  public hydrate(data: SerializedData): void {
    super.hydrate(data);
    if (this.isStubMode({ ...data.appConfig })) {
      this.bexApiSource.clientConfigs.bexApiUrl = data.appConfig.graphqlStubURL;
    } else {
      this.bexApiSource.clientConfigs.bexApiUrl = data.appConfig.graphqlClientURL;
    }
  }

  private isStubMode(appConfig: KeyedObject): boolean | string {
    return (
      appConfig &&
      appConfig.environment &&
      appConfig.environment.name !== 'production' &&
      document &&
      document.cookie &&
      document.cookie.includes('lxpwastubmode=true')
    );
  }
}
